import { gql } from "generated-graphql";

export const SKILLS_QUERY = gql(`
  query Skills(
    $tenantId: ID!
    $search: String
    $enabled: Boolean
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    skills(
      tenantId: $tenantId
      search: $search
      enabled: $enabled
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      count
      items {
        id
        slug
        displayName
        description
        storagePrefix
        scope
        audience
        enabled
        tenantId
        ownerUserId
        updatedAt
      }
    }
  }
`);

export const CREATE_SKILL_MUTATION = gql(`
  mutation CreateSkill($input: CreateSkillInput!) {
    createSkill(input: $input) {
      id
      slug
      displayName
      description
      storagePrefix
      scope
      audience
      enabled
      tenantId
      ownerUserId
      updatedAt
    }
  }
`);

export const UPDATE_SKILL_MUTATION = gql(`
  mutation UpdateSkill($input: UpdateSkillInput!) {
    updateSkill(input: $input) {
      id
      slug
      displayName
      description
      storagePrefix
      scope
      audience
      enabled
      tenantId
      ownerUserId
      updatedAt
    }
  }
`);

export const DELETE_SKILL_MUTATION = gql(`
  mutation DeleteSkill($input: DeleteSkillInput!) {
    deleteSkill(input: $input)
  }
`);

export const SKILL_FILES_QUERY = gql(`
  query SkillFiles($input: SkillIdInput!) {
    skillFiles(input: $input) {
      path
      size
      updatedAt
    }
  }
`);

export const SKILL_FILE_CONTENT_QUERY = gql(`
  query SkillFileContent($input: SkillFileInput!) {
    skillFileContent(input: $input)
  }
`);

export const WRITE_SKILL_FILE_MUTATION = gql(`
  mutation WriteSkillFile($input: WriteSkillFileInput!) {
    writeSkillFile(input: $input) {
      path
      size
      updatedAt
    }
  }
`);

export const DELETE_SKILL_FILE_MUTATION = gql(`
  mutation DeleteSkillFile($input: SkillFileInput!) {
    deleteSkillFile(input: $input)
  }
`);
